export default __webpack_public_path__ + "static/media/article.4b63c5de.png";